<template>
    <v-page-content>
        <v-content-info-page></v-content-info-page>
    </v-page-content>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { types } from '@/config/content/types'

export default {
  name: 'SelectedNews',
  data() {
    return {
      selectedId: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.selectedId = to.params.newsId
    this.getData()
    next()
  },
  created() {
    this.selectedId = this.$route.params.newsId
    this.getData()
  },
  methods: {
    ...mapActions({
      fetchSelectedNews: 'content/fetchSelectedContent'
    }),
    ...mapMutations({
      setContentType: 'content/setContentType'
    }),
    getData() {
      this.fetchSelectedNews(this.selectedId).then((data) => {
        if (data) {
          this.$router.push('/page_not_exist')
        } else {
          this.setContentType(types.news)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
